import { createStore } from 'vuex'

export default createStore({
    state: {
        // baseUrl: 'https://test.inkai.info/api/'
        baseUrl: 'https://inkai.info/api/'
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    },
    modules: {
    }
})
